export default {
    account:'Account',
    mainAccount: 'Main Account',
    organizationOfAccountDetails: 'Organization of account details',
    billingProfile: 'Billing Profile',
    fullDetailsOfAccountProfile: 'Full details of account profile',
    idNumber: 'ID Number',
    website: 'Website',
    business: 'Business',
    fullAddressDetailsOfAccountInformation: 'Full Address Details Of Account Information',

    updateProfile: 'Update Profile',

};